import { RULESET_VERSION } from '@core/rulesetVersion';

/**
 * Shared canonical contract across UI mapping, engine, and persisted docs.
 */
export const ATLAS_DATA_CONTRACT_VERSION = '1.0.0';

/**
 * UI mapping registry version (implementation detail).
 */
export const UI_MAPPING_VERSION = ATLAS_DATA_CONTRACT_VERSION;

/**
 * Engine ruleset version (implementation detail).
 */
export const ENGINE_RULESET_VERSION = RULESET_VERSION;

/**
 * Migrate a persisted document from one data contract version to another.
 *
 * This is a no-op pipeline for v1.0.0. When the data contract version is bumped,
 * add a migration step here to transform old field shapes to the new schema.
 *
 * @param doc  - The raw parsed document payload (spread before calling to avoid modifying the original)
 * @param _fromVersion - Contract version the document was originally saved under (or 'pre-contract')
 * @param _toVersion   - Target contract version (current ATLAS_DATA_CONTRACT_VERSION)
 * @returns The (potentially modified) document
 */
export function migrateDoc<T extends Record<string, unknown>>(
  doc: T,
  _fromVersion: string,
  _toVersion: string,
): T {
  // v1.0.0 → v1.0.0: nothing to transform.
  // Add migration steps here as the contract evolves, e.g.:
  //   if (_fromVersion === '1.0.0' && _toVersion === '1.1.0') { ... }
  return doc;
}

